<template>
  <div class="news " :class="[ getTerminalForChrome() ? 'news-mo': 'news-pc']">
   <div class="header ">
     <div class="logo">
       <div class="logo-l">
         <img src="../../../assets/logo.png" alt="">
       </div>
       <div class="logo-r">
        <span class="text1">广报高山学校</span>
        <span class="text2"></span>
       </div>
     </div>
      <div class="nav" v-if="!getTerminalForChrome()">
        <div class="nav-item" v-for="(v, i) in menuList" :key="i">
          <div class="item-fa"
          :class="[v.actived?'active1':'un-active1']"
          @click="handleClick(v, '')"
          >
            {{v.title}}
          </div>
          <div v-if="v.children && v.title !== '学校概况'" class="item-sons">
            <div class="item-son" :class="{'active2':m.actived}" v-for="(m, n) in v.children" :key="n" @click="handleClick(v, m)">
              {{m.title}}
            </div>
          </div>
        </div>
      </div>
      <div class="nav-mo" @click="showNav" v-else>
        <img src="../../../assets/nav.jpg" alt="">
        <!-- <span class="line"></span> -->
        <!-- <span class="line"></span> -->
        <!-- <span class="line"></span> -->
      </div>
   </div>
   <div class="mask" v-if="showMe">
     <div class="show-nav">
       <div class="top">
         <img src="../../../assets/close.png" alt="" @click="closeNav">
       </div>
       <div class="item" v-for="(v, i) in menuList" :key="i">
         <div class="item-fa" @click="showSub(v);toPage(v.url, v)">
          <div class="title">{{v.title}}</div>
          <div class="to" v-if="v.children && v.children.length">
            <img v-if="!v.show" src="../../../assets/right.png" alt="">
            <img v-else src="../../../assets/down.png" alt="">
          </div>
         </div>
         <div class="item-sons" v-if="v.children && v.children.length && v.show">
           <div class="item-son" v-for="(m, n) in v.children" :key="n" @click="toPage(m.url, v)">
             {{m.title}}
           </div>
         </div>
       </div>
     </div>
     <div class="hide" @click="closeNav"></div>
   </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  props: {
    menuList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      showMe: false
    }
  },
  mounted () {
  },
  watch: {
  },
  methods: {
    ...mapGetters(['getTerminalForChrome']),
    toPage(url, v) {
      if (url) {
        this.$router.push({
          path: url
        })
        document.querySelector('body').position = 'static'
        v.show = false
        this.showMe = false
      }
    },
    closeSub(v) {
      v.show = false
    },
    showSub(v) {
      v.show = !v.show
    },
    closeNav() {
      document.querySelector('body').position = 'static'
      this.showMe = false
    },
    showNav() {
      this.showMe = true
      document.body.position = 'fixed'
    },
    handleClick (v, m) {
      if (v.url) {
        this.$emit('change', v, m)
      } else if (m.url) {
        this.$emit('change', v, m)
      }
    }
  },
  created () {
  }

}
</script>

<style scoped lang="scss">
.news-pc {
  // width: 100vw;
  display: flex;
  justify-content: center;
  .header {
    // width: 1440px;
    width: 75%;
    // opacity: 0;
    background-color: transparent;
    position: relative;
    height: 124px;
    // transform: scaleX(-1) scaleY(-1);
    // transform: scaleX(-1) scaleY(-1);
    // background-image: linear-gradient(180deg, #47B97E 0%, #327ADF 80%);
    // opacity: 0.21;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // justify-content: flex-end;
    .logo {
      width: 316px;
      height: 100%;
      display: flex;
      align-items: center;
      padding-top: 22px;
      .logo-l {
        height: 80px;
        width: 80px;
        margin-right: 12px;
        display: inherit;
        img {
          display: inline-block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .logo-r {
        span {
          display: block;
          // width: 200px;
          height: 20px;
          line-height: 20px;
          color: #fff;
        }
        .text1 {
          font-size: 26px;
          margin-bottom: 0px;
          //font-size: 20px;
          //margin-bottom: 8px;
          white-space: nowrap;
        }
        .text2 {
          //height: 0px;
          font-size: 20px;
        }
      }
    }
    .nav {
      width: calc(100% - 316px);
      display: flex;
      // flex-wrap: nowrap;
      flex-wrap: nowrap;
      justify-content: space-around;
      padding-left: 64px;
      .nav-item {
        position: relative;
        // min-width: 84px;
        // width: 16.66%;
        // height: 40px;
        margin-top: 8px;
        height: calc(40px + 8px);
        cursor: pointer;
        &:not(:last-child) {
          // margin-right: 104px;
        }
        &:hover {
          .item-sons {
            display: block;
          }
        }
        .item-fa {
          // display: flex;
          // align-items: center;
          box-sizing: border-box;
          height: 40px;
          // justify-content: center;
          // border-radius: 20px;
          display: inline-block;
          line-height: 40px;
          text-align: center;
          //color: #31a087;
          color: #FFFFFF;
          letter-spacing: 0;
          font-size: 20px;
          position: relative;
          padding: 0px 4px;
          // border: 1px solid #FFFFFF;
          &.un-active1::after {
            content: '';
            display: block;
            height: 3px;
            width: 0;
            background: transparent;
            transition: width .5s ease, background-color .5s ease;
          }
          &.un-active1:hover::after {
            width: 100%;
            background: #fff;
          }
          &.active1::before {
              content: '';
              display: block;
              position: absolute;
              left: 0;
              bottom: 0;
              height: 3px;
              width: 100%;
              transition: width 0s ease;
          }
          &.active1::after {
              content: '';
              display: block;
              position: absolute;
              right: 0;
              bottom: 0;
              height: 3px;
              width: 100%;
              //background: #31a087;
              background: #fff;
              transition: width .5s ease;
          }
          &.active1:hover::before {
              width: 0%;
              //background: #31a087;
            background: #fff;
              transition: width .5s ease;
          }
          &.active1:hover::after {
              width: 0%;
              background: transparent;
              transition: width 0s ease;
          }
        }
        .item-sons {
          display: none;
          position: absolute;
          top: calc(40px + 8px);
          left: -50%;
          min-width: 182px;
          padding: 0px 16px;
          font-size: 20px;
          opacity: 0.8;
          background: #001617;
          border: 1px solid #000000;
          box-shadow: 0 0 20px 0 rgba(185,185,185,0.52);
          .item-son {
            white-space: nowrap;
            color: #D8D8D8;
            padding: 16px 0px;
            display: flex;
            align-items: center;
            justify-content: center;
            &:not(:last-child){
              border-bottom: 1px solid #A1A1A1;
            }
            &.active2 {
              color: #31a087
            }
            &:hover {
              color: #48e6c1;
            }
          }
        }
      }
    }
    .line-list {
      position: relative;
      width: 55px;
      height: 50px;
      .line {
        width: 17px;
        height: 3px;
        background-color: #fff;
        position: absolute;
        z-index: 5;
        left: 50%;
        top: 16px;
      }
      .line-2 {
        top: 25px;
        width: 25px;
      }
      .line-3 {
        top: 33px;
        width: 21px;
      }
      .trans {
        transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1) 0s;
      }
      .trans-fast {
        transition: all 200ms ease-in-out;
      }
      .closed {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

.news-mo {
  .header {
    width: 100vw;
    height: 25.07vw;
    // background: url('../../../assets/head.jpeg') no-repeat center center;
    // background-size: cover;
    padding: 0vw 5.33vw 0vw 6.8vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .logo {
      display: flex;
      align-items: center;
      .logo-l {
        width: 13.1vw;
        height: 13.1vw;
        margin-right: 2.91vw;
        img {
          width: 100%;
          height: 100%;
          object-fit: fill;
        }
      }
      .logo-r {
        span {
          display: block;
          color: #FFFFFF;
        }
        .text1 {
          font-size: 3.2vw;
        }
        .text2 {
          font-size: 2.67vw;
        }
      }
    }
    .nav-mo {
      width: 6.93vw;
      img {
        width: 100%;
      }
      .line {
        display: block;
        width: 6.93vw;
        height: 0.4vw;
        background: #fff;
        &:not(:last-child) {
          margin-bottom: 1.07vw;
        }
      }
    }
  }
  .mask {
    // display: none;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;
    position: fixed;
    z-index: 999;
    background-color: rgba(0,0,0,.6);
    top: 0;
    left: 0;
    overflow: hidden;
    display: flex;
    .show-nav {
      background-color: #fff;
      width: 70.39vw;
      height: 100vh;
      overflow-y: auto;
      .top {
        width: 100%;
        height: 16vw;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 2.13vw;
        img {
          width: 7.8vw;
        }
      }
      .item {
        .item-fa {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 13.07vw;
          border-bottom: 0.13vw solid #000;
          padding: 0vw 5.33vw;
          .title {
            font-size: 4.27vw;
            color: #000;
          }
          .to {
            width: 4vw;
            height: 4vw;
            img {
              width: 100%;
            }
          }
        }
        .item-sons {
          .item-son {
            height: 11.73vw;
            display: flex;
            align-items: center;
            font-size: 3.73vw;
            color: #000;
            padding: 0vw 5.33vw;
            margin-left: 5.33vw;
            transition: all 0.5s;
          }
        }
      }
      // width: ;
    }
    .hide {
      flex: 1;
    }
  }
}
</style>
